import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment.prod'

import { catchError } from 'rxjs/operators';

import { AuthService } from '../shared/guards/auth.service';


import { Observable, of } from 'rxjs';
import { UserModel, StaffModel } from '../models/commModel';

// import { Observable } from 'rxjs/dist/types/internal/Observable';
// import { of } from 'rxjs/dist/types/internal/Observable/of';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem('ACCESS_TOKEN'),
        'timezoneInt': ((new Date().getTimezoneOffset() / 60) * -1).toString(),
        "location": "Hong_Kong"
    })
};

@Injectable({
    providedIn: 'root'
})
export class UserService {

    Token: string;
    userId: string;
    GoToBooking: boolean;
    private apiurl = environment.apiurl;

    constructor(
        private http: HttpClient,
        private authService: AuthService) {
        this.Token = this.authService.getToken();
        this.userId = this.authService.getUserId();
    }

    selectedDate: any;
    tempBooking: any;
    booking: any;
    confirmBooking: any;
    rescheduleBooking: any;

    addBooking: any = false;
    updateBooking: any = false;

    log() {
        console.log(this.tempBooking);
        console.log(this.booking);
        console.log(this.rescheduleBooking);
    }

    Reset() {
        this.selectedDate = null;
        this.tempBooking = null;
        this.booking = null;
        this.confirmBooking = null;
        this.rescheduleBooking = null;
    }

    AddNonHKCCUser(model: any): Observable<any> {
        return this.http.post<any>(this.apiurl + "User/AddNonHKCCUser", model, httpOptions)
            .pipe(
                //catchError(this.handleError<UserModel>())
            );
    }

    ChangePassword(model: any): Observable<any> {
        this.Token = this.authService.getToken();
        this.userId = this.authService.getUserId();
        httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + this.Token);
        httpOptions.headers = httpOptions.headers.set('UserId', this.userId);
        return this.http.post<any>(this.apiurl + "User/ChangePassword", model, httpOptions)
            .pipe(
                //catchError(this.handleError<UserModel>())
            );
    }
}
